import { render } from "./pop_detail.vue?vue&type=template&id=df71cd30"
import script from "./pop_detail.vue?vue&type=script&lang=js"
export * from "./pop_detail.vue?vue&type=script&lang=js"

import "./pop_detail.vue?vue&type=style&index=0&id=df71cd30&lang=scss"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__